import { getLangFromUrl } from "./url-helpers";

export const getDirection = () => {
  return getLangFromUrl().toLowerCase() == "heb" ? "rtl" : "ltr";
};

export const fitString = (string, numOfChars) => {
  let result = string.substring(0, numOfChars);
  result = result + "... ";
  return result;
};

/**
 *
 * @param {string} strA first string to compare
 * @param {string} strB second string to compare
 * @param {bool} ignoreCase should ignore case
 */
export const stringEquals = (strA = "", strB = "", ignoreCase = true) => {
  if (ignoreCase) {
    return strA === strB;
  } else {
    return strA.toLowerCase() === strB.toLowerCase();
  }
};



// WEBPACK FOOTER //
// ./src/helpers/string-helpers.js